import { TwoFactorStep } from '../enums/two-factor-step';

export const getInitialTwoFactorStep = (password: string | undefined, requireSetup: boolean | undefined) => {
  // If setup is required we possibly need to get user if it is not provided via location state from previous password flow
  if (requireSetup) {
    // Ask for password since we need it to enable two-factor for user
    if (!password) {
      return TwoFactorStep.Password;
    }

    // If password is provided, we can skip straight to setup
    return TwoFactorStep.Setup;
  }

  // If setup is not required, we can go straight to verify step which does not require password
  return TwoFactorStep.Verify;
};
